import { ToastNotification } from '../../shared/components/ToastNotification'
import {
  ReviewsBreadcrumb as Breadcrumb,
  ReviewsFilters as Filters,
  ReviewsProductListingHeader,
  ReviewsProducts,
  ReviewsSortby,
} from '../components/'

export const useProductListingComponents = () => ({
  // When adding new components here, you will need to log in to Glide,
  // create a system widget, then add the widget into the page layout

  Breadcrumb,
  Filters,
  ReviewsProducts,
  ReviewsProductListingHeader,
  ReviewsSortby,
  ToastNotification,
})
